(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["press-blog"]) return;
  try {
    
function resize(){
	let categories = ['celebrities','influencers'];
	let cats = categories.map(a=> `.press .${a}`).join(' , ');
	$(cats).each( function(){
		$(this).height( $(this).width() )}
	);
};
function resizeLoaded(el){
	let categories = ['celebrities','influencers'];
	if( $(el).is('.' + categories.join(' , ')) ){
	$(el).height( $(el).width() );
}


console.log('resize the el')
};

	$(document).ready(function(){
			resize();
			$(window).on('resize', resize);
	})


	$('.lightbox > section > div').wrapInner( "<div class='slick'></div>");
	console.log('did it change');
	$('.lightbox .slick img').wrap('<section />');
		
	$('.cats li').click(function(e){
		updateLazy()
		if($(e.currentTarget).hasClass('active')){
			$(e.currentTarget).removeClass('active');
		}else{
          $.each($('.cats li'),function(i,v){
              $(v).removeClass('active');
          });
					$(e.currentTarget).addClass('active');
					let itemCat = $(this).data('cat');
					mySortPress( itemCat );
		}
	});

	function mySortPress(cat){

		allClasses = $(`.press li[data-cat]`);
		if(cat == 'all'){
			activeClasses = $(`.press li[data-all]`);
			lastActive = $(`.press li[data-all]:last`);
		}else{
			activeClasses = $(`.press li[data-cat="${cat}"]`);
			lastActive = $(`.press li[data-cat="${cat}"]:last`);
		}
		// Remove all `active` classes
		allClasses.removeClass('active').hide().css({position: 'absolute'});
		// Add `active` class to all images
		activeClasses.addClass('active').css({position: 'static'}).show();
		resize();
	};

	
	$('.press li img').click(function(e){
		
		$($(e.currentTarget).parent()).find('.lightbox').fadeIn();
		$($(e.currentTarget).parent()).find('.slick').slick();
		
	});
	$('.lightbox span').click(function(e){
		$($(e.currentTarget).parent().parent()).fadeOut();
	});
	$('.lightbox').click(function(e){
	
	if($(e.target).hasClass('lightbox')){
		$(e.target).fadeOut();
		$(e.currentTarget).find('.slick').slick('unslick');
	}
	});
jQuery(document).ready(function($){

	function triggerOneEight() {
      $( "#teen" ).delay( 400 ).trigger( "click" );
	  $( "#fade-it-in" ).fadeIn( 800 );
    };
	setTimeout(triggerOneEight, 1400)


});
// Set up lazy loading

var lazyLoadInstance = new LazyLoad({
	elements_selector: ".lazy",
	callback_loaded: resizeLoaded,
	callback_finish: resizeLoaded
// ... more custom settings?
});

function updateLazy(){
	if (lazyLoadInstance) {
		lazyLoadInstance.update();
	}
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
